import { createGetEndpoint } from '@sonar-software/sonar-http';

export const getDataSecurityStatus = createGetEndpoint<void, boolean>(
	'/api/v3/data-security/management/enabled'
);
